import { render, staticRenderFns } from "./FileInputIKP.vue?vue&type=template&id=e2a680d8&scoped=true&lang=html&"
import script from "./FileInputIKP.vue?vue&type=script&lang=js&"
export * from "./FileInputIKP.vue?vue&type=script&lang=js&"
import style0 from "./FileInputIKP.vue?vue&type=style&index=0&id=e2a680d8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a680d8",
  null
  
)

export default component.exports